module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('edit-pane', {
    ref: "step4",
    on: {
      "save": _vm.onSave,
      "cancel": _vm.onCancel,
      "edit": _vm.onEdit
    }
  }), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('select-action-status', {
    attrs: {
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.step4.status),
      callback: function($$v) {
        _vm.$set(_vm.step4, "status", $$v)
      },
      expression: "step4.status"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', [_c('select-priority', {
    attrs: {
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.step4.priority),
      callback: function($$v) {
        _vm.$set(_vm.step4, "priority", $$v)
      },
      expression: "step4.priority"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', _vm._l((_vm.step4.actions), function(ref, index) {
    return _c('el-tab-pane', {
      key: ref.id,
      attrs: {
        "border-card": "",
        "label": ref.name + ' Renewal',
        "name": ref.name
      }
    }, [_c('el-form', {
      attrs: {
        "label-position": "top"
      }
    }, [_c('el-row', {
      attrs: {
        "gutter": 8
      }
    }, [_c('el-col', {
      attrs: {
        "xs": 24,
        "sm": 12,
        "md": 12,
        "lg": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": ref.name + ' Ref'
      }
    }, [_c('el-input', {
      attrs: {
        "id": 'renref' + index,
        "placeholder": ref.name + ' Ref.',
        "disabled": _vm.dis
      },
      model: {
        value: (ref.ref),
        callback: function($$v) {
          _vm.$set(ref, "ref", $$v)
        },
        expression: "ref.ref"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": ref.name + ' Amount'
      }
    }, [_c('text-input', {
      attrs: {
        "type": "number",
        "id": 'renamnt' + index,
        "placeholder": "Amount",
        "disabled": _vm.dis
      },
      model: {
        value: (ref.fee),
        callback: function($$v) {
          _vm.$set(ref, "fee", $$v)
        },
        expression: "ref.fee"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "xs": 24,
        "sm": 12,
        "md": 12,
        "lg": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": ref.name + ' Cheque #'
      }
    }, [_c('el-input', {
      attrs: {
        "id": 'renchq' + index,
        "placeholder": "Chq No",
        "disabled": _vm.dis
      },
      model: {
        value: (ref.chqNo),
        callback: function($$v) {
          _vm.$set(ref, "chqNo", $$v)
        },
        expression: "ref.chqNo"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": ref.name + ' Chg. Received'
      }
    }, [_c('el-date-picker', {
      attrs: {
        "id": 'renrecv' + index,
        "format": _vm.dateFormat,
        "placeholder": "Chq Received",
        "disabled": _vm.dis
      },
      model: {
        value: (ref.chqDate),
        callback: function($$v) {
          _vm.$set(ref, "chqDate", $$v)
        },
        expression: "ref.chqDate"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "xs": 24,
        "sm": 12,
        "md": 12,
        "lg": 8
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": ref.name + ' Submitted'
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": _vm.dateFormat,
        "id": 'rensub' + index,
        "placeholder": "Submitted",
        "disabled": _vm.dis
      },
      model: {
        value: (ref.submittedOn),
        callback: function($$v) {
          _vm.$set(ref, "submittedOn", $$v)
        },
        expression: "ref.submittedOn"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": ref.name + ' Status'
      }
    }, [_c('el-select', {
      attrs: {
        "format": _vm.dateFormat,
        "id": 'renstat' + index,
        "placeholder": "Status",
        "disabled": _vm.dis
      },
      model: {
        value: (ref.status),
        callback: function($$v) {
          _vm.$set(ref, "status", $$v)
        },
        expression: "ref.status"
      }
    }, _vm._l((_vm.status), function(st) {
      return _c('el-option', {
        key: st.type,
        attrs: {
          "label": st.type,
          "value": st.type
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": ref.name + ' Decision'
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": _vm.dateFormat,
        "id": 'rensd' + index,
        "placeholder": "Status Date",
        "disabled": _vm.dis
      },
      model: {
        value: (ref.statusDate),
        callback: function($$v) {
          _vm.$set(ref, "statusDate", $$v)
        },
        expression: "ref.statusDate"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('html-input', {
      attrs: {
        "label": ref.name + ' Remarks',
        "id": 'renrem' + index,
        "placeholder": "Remarks",
        "disabled": _vm.dis
      },
      model: {
        value: (ref.remarks),
        callback: function($$v) {
          _vm.$set(ref, "remarks", $$v)
        },
        expression: "ref.remarks"
      }
    })], 1)], 1)], 1)], 1)
  }), 1), _vm._v(" "), (_vm.rowData.id) ? _c('files-panel', {
    attrs: {
      "type": "site",
      "id": _vm.rowData.site_id,
      "process": "progress",
      "process-id": _vm.rowData.id,
      "disabled": _vm.dis,
      "max-files": 20
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ed8b3a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/progress/ProgressStep4.vue
// module id = 1526
// module chunks = 0